import { principles } from '@/mocks/home';

export default function Principles() {
  return (
    <section className="bg-secondary-100/60">
      <div className="mx-auto w-full max-w-6xl px-4 py-14 md:px-6 md:py-20">
        <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
          <div className="flex flex-col gap-2">
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-accent-700">吃瓜守则</p>
            <h2 className="font-heading text-2xl font-black tracking-tight text-foreground-950 md:text-4xl">有料，也要有底线</h2>
          </div>
          <p className="max-w-md text-sm leading-relaxed text-foreground-700 md:text-right">
            吃瓜王是一群爱看热闹、更讲道理的人做的年度盘点。热闹要赶，分寸也要拿捏。
          </p>
        </div>

        <div className="mt-9 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {principles.map((p) => (
            <div key={p.t} className="rounded-3xl border border-secondary-200 bg-background-50 p-6">
              <span className="flex h-11 w-11 items-center justify-center rounded-2xl bg-secondary-200/70 text-secondary-800">
                <i className={`${p.icon} text-xl`}></i>
              </span>
              <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">{p.t}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-700">{p.d}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}